import React from "react";
import Legal from "./index";

export default () => <Legal name="accessibility" />;



// WEBPACK FOOTER //
// ./src/components/areas/Legal/Accessibility.js